/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserHistoryObservedEmergencyModel
 */
export interface UserHistoryObservedEmergencyModel {
    /**
     * 
     * @type {boolean}
     * @memberof UserHistoryObservedEmergencyModel
     */
    chat_opened: boolean;
    /**
     * 
     * @type {number}
     * @memberof UserHistoryObservedEmergencyModel
     */
    creation_timestamp: number;
    /**
     * 
     * @type {string}
     * @memberof UserHistoryObservedEmergencyModel
     */
    creator_auth_id: string;
    /**
     * 
     * @type {string}
     * @memberof UserHistoryObservedEmergencyModel
     */
    creator_first_name: string;
    /**
     * 
     * @type {string}
     * @memberof UserHistoryObservedEmergencyModel
     */
    creator_last_name: string;
    /**
     * 
     * @type {string}
     * @memberof UserHistoryObservedEmergencyModel
     */
    incident: string;
    /**
     * 
     * @type {string}
     * @memberof UserHistoryObservedEmergencyModel
     */
    org_code: string;
    /**
     * 
     * @type {string}
     * @memberof UserHistoryObservedEmergencyModel
     */
    group_name: string;
    /**
     * 
     * @type {number}
     * @memberof UserHistoryObservedEmergencyModel
     */
    resolved_timestamp?: number | null;
}

/**
 * Check if a given object implements the UserHistoryObservedEmergencyModel interface.
 */
export function instanceOfUserHistoryObservedEmergencyModel(value: object): value is UserHistoryObservedEmergencyModel {
    if (!('chat_opened' in value) || value['chat_opened'] === undefined) return false;
    if (!('creation_timestamp' in value) || value['creation_timestamp'] === undefined) return false;
    if (!('creator_auth_id' in value) || value['creator_auth_id'] === undefined) return false;
    if (!('creator_first_name' in value) || value['creator_first_name'] === undefined) return false;
    if (!('creator_last_name' in value) || value['creator_last_name'] === undefined) return false;
    if (!('incident' in value) || value['incident'] === undefined) return false;
    if (!('org_code' in value) || value['org_code'] === undefined) return false;
    if (!('group_name' in value) || value['group_name'] === undefined) return false;
    return true;
}

export function UserHistoryObservedEmergencyModelFromJSON(json: any): UserHistoryObservedEmergencyModel {
    return UserHistoryObservedEmergencyModelFromJSONTyped(json, false);
}

export function UserHistoryObservedEmergencyModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserHistoryObservedEmergencyModel {
    if (json == null) {
        return json;
    }
    return {
        
        'chat_opened': json['chat_opened'],
        'creation_timestamp': json['creation_timestamp'],
        'creator_auth_id': json['creator_auth_id'],
        'creator_first_name': json['creator_first_name'],
        'creator_last_name': json['creator_last_name'],
        'incident': json['incident'],
        'org_code': json['org_code'],
        'group_name': json['group_name'],
        'resolved_timestamp': json['resolved_timestamp'] == null ? undefined : json['resolved_timestamp'],
    };
}

export function UserHistoryObservedEmergencyModelToJSON(json: any): UserHistoryObservedEmergencyModel {
    return UserHistoryObservedEmergencyModelToJSONTyped(json, false);
}

export function UserHistoryObservedEmergencyModelToJSONTyped(value?: UserHistoryObservedEmergencyModel | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'chat_opened': value['chat_opened'],
        'creation_timestamp': value['creation_timestamp'],
        'creator_auth_id': value['creator_auth_id'],
        'creator_first_name': value['creator_first_name'],
        'creator_last_name': value['creator_last_name'],
        'incident': value['incident'],
        'org_code': value['org_code'],
        'group_name': value['group_name'],
        'resolved_timestamp': value['resolved_timestamp'],
    };
}

